import { h, createRef } from 'preact';
import register from '@wcd/preact-custom-element';
import { useState, useEffect } from 'preact/hooks';
import { useContext } from './context';
import { Reviews } from '../../../types/web-components';

const REVIEWS_PER_CLICK = 5;

export const component: Reviews = ({ children }) => {
  const ref: any = createRef();
  const [resourceId, setResourceId] = useState<number | undefined>(undefined);
  const [cursor, setCursor] = useState<number>(0);
  const [count, setCount] = useState<number>(0);

  const loadMoreReviews = async () => {
    try {
      if (cursor < Number(count)) {
        const response = await fetch(`reviews/${resourceId}?cursor=${cursor}&limit=${REVIEWS_PER_CLICK}`, {})
        const html = await response.text();
        const newReviewElements = document.createRange().createContextualFragment(html);
        ref.current.appendChild(newReviewElements);

        setCursor((oldCursor) => oldCursor + REVIEWS_PER_CLICK);
      }
    } catch (e) {
      console.error(e);
    }
  };

  useContext(({ resource }) => {
    const { resourceId, reviews } = resource;
    const { cursor, count } = reviews || {};

    setResourceId(resourceId);
    setCursor(cursor || 0);
    setCount(count || 0);
  });

  useEffect(() => {
    const seeMoreCta = document.querySelector('#see-more__cta');
    if (cursor !== 0 && cursor >= Number(count)) return seeMoreCta?.remove();
    seeMoreCta?.addEventListener('click', loadMoreReviews);
    return () => seeMoreCta?.removeEventListener('click', loadMoreReviews);
  }, [resourceId, cursor])

  const { id, children: reviewElements } = children[0].props;
  return (
    <div id={id} ref={ref}>
      {reviewElements}
    </div>
  );
};

register(component, 'tes-reviews', ['reviews'], { shadow: false });
